exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-box,\n.register-box {\n  width: 600px;\n  margin: 4% auto;\n}\n.login-box-body,\n.register-box-body {\n  background: #fff;\n  padding: 20px;\n  border-top: 0;\n  color: #666;\n}\n.login-box-body .form-control-feedback,\n.register-box-body .form-control-feedback {\n  color: #777;\n}\n.login-box-msg,\n.register-box-msg {\n  margin: 0;\n  text-align: center;\n  padding: 0 20px 20px 20px;\n  color:#009995;\n}\n\n.btn-primary{\n  background-color: #00c4c3;\n  border-color: #00c4c3;\n  font-weight: bold;\n}\n.form-control {\n    color: #74746F;\n}\n\n.label-warning {\n    background-color: #f0ad4e;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/register-component/register-component.component.css
// module id = ../../../../../src/app/pages/register-component/register-component.component.css
// module chunks = main